export default __webpack_public_path__ + "static/media/BannerImage.3310ba49.png";